import React from 'react';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {businessCardinfo, submitEvaluation} from '../../actions/businessCard.js';
import secm from '@baidu/sec-monitor';
import {Button, Modal, Form, FormItem, Toast} from '@baidu/spui';
import Popover from 'antd/lib/popover';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Pagination, Navigation, Autoplay} from 'swiper';
import ContactItem from '../../../src/components/ContactItem';
import iconWechat from '../../../src/pages/normalLandPage/imgs/pc-icon-weixin.svg';
import iconWeibo from '../../../src/pages/normalLandPage/imgs/pc-icon-weibo.svg';
// import 'swiper/components/navigation/navigation.less';
import iconScan from '../../asset/img/scan.svg';
import './newCard.less';
import {getUrlValue} from '../../util';
import {SPEC_COMP_LIST} from '../../constants/specCompanyList.js';

SwiperCore.use([Pagination, Navigation, Autoplay]);

export class BusinessCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tempCompanyName: '北京趣拿信息技术有限公司',
            tempCompanyNetUrl: 'https://user.qunar.com/mobile/login.jsp?'
                + encodeURIComponent('ret=https%3A%2F%2Fm.flight.qunar.com%2Fh5%2Fflight%2Ffwpview%2F'
                + 'ext%2FkefuOrderList%3Fsource%3Dbaidu'),
            company: {},
            current: 0,
            show: false,
            showtitle: '',
            tagOptions: [{
                txt: '电话接通速度',
                status: 0,
            }, {
                txt: '号码准确',
                status: 0,
            }, {
                txt: '问题得到解决',
                status: 0
            }],
            formData: {
                textarea1: '',
                r: 0,
                a: 0,
                s: 0,
            }


        };
    }

    componentDidMount() {
        const cn = decodeURIComponent(getUrlValue('company-name'));
        const showtitle = getUrlValue('showtitle') ? decodeURIComponent(getUrlValue('showtitle')) : '';
        this.setState({showtitle});
        this.init(cn, showtitle);
    }

    onSlideChange(e) {
        this.setState({
            current: e.activeIndex
        });
    }
    selpj(it) {
        const cloneTag = JSON.parse(JSON.stringify(this.state.tagOptions));
        const clForm = {...this.state.formData};
        switch (it.txt) {
            case '电话接通速度':
                if (it.status === 0) {
                    _hmt.push(['_trackEvent', 'newcard', 'click', 'evaluation-r']);
                    secm.action('evaluation-r', 'click', '1');
                    cloneTag[0].status = 1;
                    clForm.r = 1;
                } else {
                    _hmt.push(['_trackEvent', 'newcard', 'click', 'evaluation-r']);
                    secm.action('evaluation-r', 'click', '0');
                    cloneTag[0].status = 0;
                    clForm.r = 0;
                }
                break;
            case '号码准确':
                if (it.status === 0) {
                    _hmt.push(['_trackEvent', 'newcard', 'click', 'evaluation-a']);
                    secm.action('evaluation-a', 'click', '1');
                    cloneTag[1].status = 1;
                    clForm.a = 1;
                } else {
                    _hmt.push(['_trackEvent', 'newcard', 'click', 'evaluation-a']);
                    secm.action('evaluation-a', 'click', '0');
                    cloneTag[1].status = 0;
                    clForm.a = 0;
                }
                break;

            case '问题得到解决':
                if (it.status === 0) {
                    _hmt.push(['_trackEvent', 'newcard', 'click', 'evaluation-s']);
                    secm.action('evaluation-s', 'click', '1');
                    cloneTag[2].status = 1;
                    clForm.s = 1;
                } else {
                    _hmt.push(['_trackEvent', 'newcard', 'click', 'evaluation-s']);
                    secm.action('evaluation-s', 'click', '1');
                    cloneTag[2].status = 0;
                    clForm.s = 0;
                }
                break;
            default:
                break;
        }
        this.setState({
            tagOptions: cloneTag,
            formData: clForm,
        });
    }

    init(cn, showtitle) {
        window.BCat_2055 && window.BCat_2055.miao();
        /* eslint-disable */
        window['__abbaidu_2055_cb'] = responseData => {
            window['__abbaidu_2055_cb'] = null;
            let localData = JSON.parse(responseData);
            this.props.businessCardinfo({
                'company_name': cn,
                'show_title': showtitle,
                data: localData.data,
                'key_id': localData['key_id'],
                sign: localData.sign
            }).then((res) => {
                const resp = res.data || {};
                resp.detailed_loc = resp.detailed_loc && JSON.parse(resp.detailed_loc);
                resp.open_info = resp.open_info && JSON.parse(resp.open_info);
                resp.company_adverts = resp.company_adverts && resp.company_adverts.split(';');
                this.setState({
                    company: resp
                });
            });
        };
        /* eslint-enable */
    }

    jump = (url) => {
        const node = document.createElement('a');
        node.setAttribute('target', '_blank');
        node.setAttribute('href', url);
        node.click();
    };

    showpj = () => {
        if (this.props.userInfo.code !== 200) {
            Toast.display({
                type: 'error',
                info: '请先登录',
                delay: 3500
            });
            return;
        }
        this.setState({
            show: true
        });
    };

    resetState() {
        const tag = [{
            txt: '电话接通速度',
            status: 0,
        }, {
            txt: '号码准确',
            status: 0,
        }, {
            txt: '问题得到解决',
            status: 0
        }];
        const formd = {
            textarea1: '',
            r: 0,
            a: 0,
            s: 0,
        };
        this.setState({
            formData: formd,
            tagOptions: tag

        });
    }

    cacel() {
        this.resetState();
        this.setState({
            show: false
        });
    }

    commitPj() {
        if (!this.state.formData.r
            && !this.state.formData.a
            && !this.state.formData.s && !this.state.formData.textarea1) {
            Toast.display({
                type: 'error',
                info: '请先完成评价',
                delay: 3500
            });
            return;
        }
        window.BCat_2055 && window.BCat_2055.miao();
        /* eslint-disable */
        window['__abbaidu_2055_cb'] = responseData => {
            window['__abbaidu_2055_cb'] = null;
            let localData = JSON.parse(responseData);
            this.props.submitEvaluation({
                'content': this.state.company.company_name,
                'user_name': this.props.userInfo.name,
                r: this.state.formData.r,
                a: this.state.formData.a,
                s: this.state.formData.s,
                d: this.state.formData.textarea1,
                data: localData.data,
                'key_id': localData['key_id'],
                sign: localData.sign
            }).then((res) => {
                this.cacel();
                if (res.code === 200) {
                    Toast.display({
                        type: 'success',
                        info: '提交成功',
                        delay: 3500
                    });
                    this.init(this.state.company.company_name, this.state.showtitle);
                } else {
                    Toast.display({
                        type: 'info',
                        info: res.message,
                        delay: 3500
                    });
                }
            });
        };
        /* eslint-enable */

    }
    // 跳转外链打点
    jumpAlias = (url, type) => {
        const {company} = this.state;
        switch (type) {
            case 'website':
                _hmt.push(['_trackEvent', 'newcard', company.company_name, 'website']);
                secm.action('newcard', company.company_name, 'website').then(res => {
                    url && this.jump(url);
                });
                break;
            case 'anotherWebsite':
                _hmt.push(['_trackEvent', 'newcard', company.company_name, 'anotherWebsite']);
                secm.action('newcard', company.company_name, 'anotherWebsite').then(res => {
                    url && this.jump(url);
                });
                break;
            default:
        }
    };
    copyCallback = (type, copyText) => {
        const {company} = this.state;
        const param = {
            title: company.company_name,
            type,
            copyText
        };
        secm.action('businessCard-copyContact', 'click', JSON.stringify(param));
    };
    formItemGetValue = ({name, value}) => {
        this.setState({formData: {
            ...this.state.formData,
            [name]: value
        }});
    };
    formateUrl = (url) => {
        if (url) {
            return url.indexOf('http') > -1 ? url : 'http://' + url;
        } else {
            return '';
        }
    };
    renderPhoneBox = (phones) => {
        if (phones && phones.length > 0) {
            const {company} = this.state;
            let phoneDisplayLength = 0;
            let phoneLength = 0;
            phones.map(item => {
                const phoneDisPlay = item.phone_display;

                if (phoneDisplayLength < phoneDisPlay.length) {
                    phoneDisplayLength = phoneDisPlay.length;
                }
                if (phoneLength < item.phone.length) {
                    phoneLength = item.phone.length;
                }
            });
            const phoneDisplayWidth = phoneDisplayLength * 14 + 'px';
            const phoneWidth = phoneLength * 9 + 'px';
            return phones.map((item, index) => {
                if (item.auth_type === 1 || item.auth_type === 3) {
                    const phoneArr = item.phone.split(';');
                    const basePhone = phoneArr[0];
                    let openInfoText = '';
                    if (item.open_info) {
                        try {
                            const tempOpenInfo = JSON.parse(item.open_info);
                            openInfoText = company.use_company_open_info === 1
                                ? `${this.renderOpenInfoItem(tempOpenInfo, '周一至周日 00:00-24:00')}`
                                : '';
                        } catch {
                            openInfoText = '';
                        }
                    }
                    return (<div key={index} className="phone-wrap">
                        <div
                            style={{width: phoneDisplayWidth}}
                            className={company.use_company_open_info === 1
                                ? 'phone-display-show'
                                : 'phone-display-show large'
                            }
                        >
                            {item.phone_display}
                        </div>
                        <div style={{width: phoneWidth}} className="phone-num-show">
                            {basePhone + (phoneArr[1] ? '转' + phoneArr[1] : '')}
                        </div>

                        {openInfoText && <div className="open-info-show">
                            {openInfoText}
                        </div>}
                    </div>);
                }
            });
        }
        return '';
    };
    renderOpenInfoItem = (openInfo, defaultText) => {
        const tempOpenInfo = openInfo || [];
        let result = [];
        if (tempOpenInfo.length > 0) {
            result = tempOpenInfo.map((v) => {
                return (v.day_range + '：' + v.open_time + '-' + v.close_time);
            });
        } else {
            result = defaultText ? defaultText : ['全天'];
        }
        return result;
    };
    renderOpenInfo = (company) => {
        return this.renderOpenInfoItem(company.open_info).join(';  ');
    };
    // 指定公司不显示认证按钮
    getShowAttestStatus = () => {
        const {company} = this.state;
        if (SPEC_COMP_LIST.includes(company.company_name)) {
            return false;
        }
        return true;
    };
    render() {
        const {company = {}, tempCompanyName, tempCompanyNetUrl} = this.state;
        const qrcodeUrl = (
            window.location.host.indexOf(':8066') > -1
            || window.location.host.indexOf('safe-mobsec06.bcc-bdbl.baidu.com') > -1)
            ? 'http://safe-mobsec06.bcc-bdbl.baidu.com:8879' : 'https://mhaoma.baidu.com';
        /* eslint-disable */
        let qrSrc = window.location.origin
            + '/api/v1/qr_code?url='
            + encodeURIComponent(
            `${qrcodeUrl}/pages/business-card/business-card?company_name=${company.company_name}&scan=true`);
        if (company.company_name === tempCompanyName) {
            qrSrc = window.location.origin
            + '/api/v1/qr_code?url=' + tempCompanyNetUrl;
        }
        let qrCode = <img className='qr-code' src={qrSrc}></img>

        const isBaidu = company.company_id === 38951;
        const websiteUrl = this.formateUrl(company.website);
        const websiteAntherUrl = this.formateUrl(company.website_sub);
        const company_introduction = company.company_introduction
            ? company.company_introduction.replace(/^\s*|\s*$/g,"") : '';

        const isShowAttestBtn = this.getShowAttestStatus();
        return (
            <div className="business-card">
                <div className="business-card-swiper">
                    <Swiper
                        slidesPerView={1}
                        style={{position: 'relative'}}
                        autoplay={true}
                        className={'business-card-swiper-box'}
                        onSlideChange={(e) => {
                            this.onSlideChange(e);
                        }}
                        pagination={{
                            clickable: true,
                            el: '.swiper-pagination1',
                            bulletClass: 'my-bullet',
                            bulletActiveClass: 'my-bullet-active'
                        }}
                        navigation={{
                            nextEl: '.swiper-button-next1',
                            prevEl: '.swiper-button-prev1'
                        }}
                    >
                        {company.company_adverts
                        && company.company_adverts.map((item, i) => {
                            return (
                                <SwiperSlide key={i}>
                                    <div className="swiper-box">
                                        <img
                                            className={'swiper'}
                                            src={item}
                                            alt=""
                                        />
                                    </div>
                                </SwiperSlide>);
                        })}
                        <div className="swiper-btn">
                            <div className={company.company_adverts
                            && company.company_adverts.length === 1
                                ? 'swiper-pagination1 my-button-hidden' : 'swiper-pagination1'}></div>
                        </div>
                    </Swiper>
                    <div className={'qyjj'}>
                        <p className={'phead'}>企业简介</p>
                        {company_introduction
                        && <p className={'jjmian'}>
                            {company.company_introduction}
                        </p>
                        }
                    </div>
                </div>
                <div className="business-card-info">
                    <p className={'title'}>
                        {company.business_card_display || company.company_name}
                    </p>
                    {(company.gold_phone_company === 1 || company.gold_phone_service === 1)
                        ? <div className={'goodcn'}>
                            {company.gold_phone_company === 1 && <div className={'goodcn-txt'}>
                                金牌接通企业
                            </div>}
                            {company.gold_phone_service === 1
                            && <div style={{marginLeft: '10px'}} className={'goodcn-txt'}>
                                优质电话服务
                            </div>}
                        </div>
                        : <div></div>
                    }
                    {company.company_switch === '1' && <div>
                        <div className={'company-info'} style={{'marginTop' : '12px'}}>
                            <div className={'msg_left'}>
                                <img
                                    className={'icon'}
                                    src={require('../../asset/img/businessCard/company-icon.svg')}
                                    alt=""
                                />
                                <span className={'ms'}>
                                    {company.company_name}
                                </span>
                            </div>
                        </div>
                    </div>}
                    {company.detailed_loc
                    && <div>
                        <div className={'company-info'}>
                            <div className={'msg_left'}>
                                <img
                                    className={'icon'}
                                    src={require('../../asset/img/businessCard/location.png')}
                                    alt=""
                                />
                                <span className={'ms'}>地址：</span>
                            </div>
                            <div className={'msg_right'}>
                                <p style={{fontFamily: 'PingFangSC-Medium'}} className={'pddr'}>
                                    {company.detailed_loc
                                    && company.detailed_loc[1].split(',')[0]
                                    === company.detailed_loc[1].split(',')[1]
                                        ? company.detailed_loc[1].split(',')[0] + company.detailed_addr
                                        : company.detailed_loc && company.detailed_loc[1].split(',')[0]
                                        !== company.detailed_loc[1].split(',')[1]
                                            ? company.detailed_loc[1].split(',').join('')
                                            + company.detailed_addr : ''
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    }
                    {company.website && <div>
                        <div className={'company-info'} style={{'marginTop' : '12px'}}>
                            <div className={'msg_left'}>
                                <img
                                    className={'icon'}
                                    src={require('../../asset/img/businessCard/website.png')}
                                    alt=""
                                />
                                <span
                                    className={'ms'}
                                >企业官网：</span>
                            </div>
                            <div className={'msg_right'}>
                                <span className={'webs'}
                                    style={{fontFamily: 'PingFangSC-Medium'}}
                                    onClick={() => this.jumpAlias(websiteUrl, 'website')}>
                                    {websiteUrl}
                                </span>
                            </div>
                        </div>
                    </div>
                    }
                    {company.company_sub_name && <p className={'title'} style={{marginTop: '30px'}}>
                        {company.company_sub_name}
                    </p>}
                    {company.company_sub_addr
                        && <div>
                            <div className={'company-info'}>
                                <div className={'msg_left'}>
                                    <img
                                        className={'icon'}
                                        src={require('../../asset/img/businessCard/location.png')}
                                        alt=""
                                    />
                                    <span className={'ms'}>地址：</span>
                                </div>
                                <div className={'msg_right'}>
                                    <p style={{fontFamily: 'PingFangSC-Medium'}} className={'pddr'}>
                                        {company.company_sub_addr}
                                    </p>
                                </div>
                            </div>
                        </div>
                    }
                    {company.website_sub && <div>
                        <div className={'company-info'} style={{'marginTop' : '12px'}}>
                            <div className={'msg_left'}>
                                <img
                                    className={'icon'}
                                    src={require('../../asset/img/businessCard/website.png')}
                                    alt=""
                                />
                                <span
                                    className={'ms'}
                                >企业官网：</span>
                            </div>
                            <div className={'msg_right'}>
                                <span className={'webs'}
                                    style={{fontFamily: 'PingFangSC-Medium'}}
                                    onClick={() => this.jumpAlias(websiteAntherUrl, 'anotherWebsite')}>
                                    {websiteAntherUrl}
                                </span>
                            </div>
                        </div>
                    </div>}
                    {company.phones?.length > 0 && <p className={'bord'}></p>}
                    <div className={'mt22 phone-detail'}>
                        <div>
                            <div className="title-label">
                                <div className="title-part">
                                    <img
                                        className={'icon'}
                                        src={require('../../asset/img/businessCard/phone.png')}
                                        alt=""
                                    />
                                    <span className={'kftxt'}>企业官方号码</span>
                                </div>
                                <div
                                    className={'pjbox'}
                                    onClick={() => {
                                        _hmt.push(['_trackEvent', 'newcard', 'click', 'goevaluation']);
                                        secm.action('newcard', 'click', 'goevaluation');
                                        this.showpj();
                                    }}
                                >
                                    <img
                                        className={'pjedit'}
                                        src={require('../../asset/img/businessCard/pjedit.svg')}
                                        alt=""
                                    />
                                    <span className={'pjshow'}>评价</span>
                                </div>
                            </div>
                            {(company.assessment && company.assessment.total)
                                ? <div className={'labelT'}>
                                {(company.assessment && company.assessment.total)
                                    ? <span className={'labelT-item'}>全部({company.assessment.total})</span>
                                    : <span></span>
                                }
                                {(company.assessment && company.assessment.r_count)
                                    ? <span className={'labelT-item'}>接通快({company.assessment.r_count})</span>
                                    : <span></span>
                                }
                                {(company.assessment && company.assessment.a_count)
                                    ? <span className={'labelT-item'}>号码准确({company.assessment.a_count})</span>
                                    : <span></span>
                                }
                                {(company.assessment && company.assessment.s_count)
                                    ? <span className={'labelT-item'}>服务好({company.assessment.s_count})</span>
                                    : <span></span>
                                }
                            </div> : <span></span>
                            }
                            {!isBaidu && !company.use_company_open_info
                                && <div className={'serviceTime'}>接通时间：
                                {this.renderOpenInfo(company)}
                            </div>}
                        </div>
                        <div className='phonebox-wrapper'>
                            {this.renderPhoneBox(company.phones)}
                            <Popover
                                overlayClassName="scan-popover"
                                trigger="hover"
                                content={qrCode}
                                placement="left"
                            >
                                <button className='scan-btn'>
                                    <img
                                        style={{'verticalAlign': 'bottom', marginRight: '5px'}}
                                        src={iconScan}
                                    ></img>
                                    <span>扫码拨号</span>
                                </button>
                            </Popover>
                        </div>

                    </div>
                    {((company.microblog && company.microblog.length > 0)
                        || (company.wechat && company.wechat.length > 0))
                    && <div>
                        <p className={'bord'}></p>
                        <div className="mt22">
                            <div className="title-label mb25">
                                <div className="title-part">
                                    <img
                                        className={'icon'}
                                        src={require('../../asset/img/businessCard/icon_qitalianxi_pc.svg')}
                                        alt=""
                                    />
                                    <span className={'kftxt'}>其他联系方式</span>
                                </div>
                            </div>
                            <div className="item-wrap">
                                {company.wechat && company.wechat.length > 0
                                    && company.wechat.map(item => {
                                        return <ContactItem
                                            key={item.id}
                                            contactIcon={iconWechat}
                                            contactName={item.name}
                                            contactSubtext={item.id}
                                            copyText={item.id}
                                            copyCallback={() => this.copyCallback('wechat-copy', item.id)}
                                            picQrCode={item.qrcode_url}
                                        />;
                                    })}
                                {company.microblog && company.microblog.length > 0
                                    && company.microblog.map((item, index) => {
                                        return <ContactItem
                                            key={index}
                                            contactIcon={iconWeibo}
                                            contactName={item.name}
                                            copyText={item.name}
                                            copyCallback={() => this.copyCallback('microblog-copy', item.name)}
                                            picQrCode={item.qrcode_url}
                                        />;
                                    })
                                }
                            </div>
                        </div>
                    </div>}

                    <div className="bottom-btn-wrapper">
                        {company.kefu_url_pc ? <Button
                            label={'联系在线客服'}
                            styleType={'modal'}
                            className={'kefu'}
                            onClick={() => this.jump(company.kefu_url_pc)}
                        >
                        </Button> : null}
                        {isShowAttestBtn && <div>
                            <Button
                                label={'企业号码认证'}
                                styleType={'ghost'}
                                className={'gorz'}
                                onClick={() => {
                                    _hmt.push(['_trackEvent', 'newcard', company.company_name, 'goattest']);
                                    secm.action('newcard', company.company_name, 'goattest');
                                    this.props.history.push('/attest/simple');
                                }}
                            >
                            </Button>
                            <p className="gorz-tip">仅企业用户可以进行认证</p>
                        </div>}
                    </div>
                </div>
                <Modal
                    width={420}
                    title={'评价'}
                    className={'pjmain'}
                    buttonReverse={true}
                    buttonType={1}
                    CancelText={'取消'}
                    // formFlag={true}
                    okText={'提交'}
                    onOk={() => {
                        _hmt.push(['_trackEvent', 'newcard', 'click', 'submit']);
                        secm.action('evaluation', 'click', 'submit');
                        this.commitPj();
                    }}
                    onCancel={() => {
                        this.cacel();
                    }}
                    visible={this.state.show}
                >
                    <Form>
                        <div className={'pjhead'}>
                            <p className={'pjcname'}>{company.company_name}</p>
                        </div>
                        <div>
                            {
                                this.state.tagOptions.map((item, i) => {
                                    return (
                                        <div key={i} className={'pjlabel'}>
                                            <div>
                                                <span className={'pjms'}>{item.txt}</span>
                                            </div>
                                            <div className={'pjsel'}>
                                                <span className={'txtgood'}>
                                                    赞一下
                                                </span>
                                                <img
                                                    className={'imgood'}
                                                    src={item.status === 1
                                                        ? require('../../asset/img/businessCard/haspj.svg')
                                                        : require('../../asset/img/businessCard/pjgood.png')}
                                                    alt=""
                                                    onClick={() => {
                                                        this.selpj(item);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        <p className={'pjtit'}>评价内容或建议</p>
                        <FormItem
                            type="textarea"
                            name={'textarea1'}
                            width={'360px'}
                            height={'120px'}
                            value={this.state.formData.textarea1}
                            resize={false}
                            placeHolder={'您还可以提交其他评价内容与建议，我们将反馈给企业，提升后续的服务质量。'}
                            getValue={this.formItemGetValue}
                        >
                        </FormItem>
                    </Form>
                </Modal>
            </div>
        );
    }
}
BusinessCard.propTypes = {
    history: PropTypes.object,
    location: PropTypes.any,
    businessCardinfo: PropTypes.func,
    userInfo: PropTypes.object,
    submitEvaluation: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
    return {
        businessCardinfo: obj => businessCardinfo(dispatch, obj),
        submitEvaluation: obj => submitEvaluation(dispatch, obj)
    };
}

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusinessCard));